import * as React from "react";
import * as AvatarPrimitive from "@radix-ui/react-avatar";
import { cn } from "../util";

/** Avatar redondo (excepción permitida) con iniciales en Bitter. */
export function Avatar({
  nombre,
  src,
  className,
}: {
  nombre: string;
  src?: string | null;
  className?: string;
}) {
  const iniciales = nombre
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase() ?? "")
    .join("");
  return (
    <AvatarPrimitive.Root
      className={cn(
        "relative flex size-9 shrink-0 overflow-hidden rounded-full bg-fondo-alzado",
        className,
      )}
    >
      {src && (
        <AvatarPrimitive.Image
          src={src}
          alt={nombre}
          className="aspect-square size-full object-cover"
        />
      )}
      <AvatarPrimitive.Fallback
        delayMs={src ? 400 : 0}
        className="flex size-full items-center justify-center font-titulo text-sm font-bold text-tinta"
      >
        {iniciales}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
